import React, { useCallback, useEffect, useState } from 'react';
import {
  clearCacheAndHardReload,
  getAuthKey,
  getUserType,
} from 'utils/local-storage/user';
// import { isMobile } from 'react-device-detect';
import {
  selectAuthLoading,
  selectAuthenticated,
} from 'modules/Authentication/slice/selectors';
import { useDispatch, useSelector } from 'react-redux';

import { BrowserRouter } from 'react-router-dom';
import DelayChild from '../Decorators/DelayChild';
// import InstallHeader from '../Decorators/InstallHeader';
// import LanguageSwitcher from 'modules/common/Language/LanguageSwitcher';
import { LazyPromptInstall } from '../PromptInstall';
import MainHelmet from 'modules/common/Decorators/MainHelmet';
import RoutesLoaderView from './components/RoutesLoaderView';
import { StyleConstants } from 'styles/StyleConstants';
import { isMobile } from 'react-device-detect';
import {
  selectInstallHeaderVisible,
  selectIsClientDomain,
} from '../slice/selectors';
import { useAuthenticationFormSlice } from 'modules/Authentication/slice';
import { useCommonFunctionSlice } from '../slice';
import { AddNewTheme } from 'styles/theme/themes';
import { selectTheme } from 'styles/theme/slice/selectors';
import { selectOrganisationUiDetails } from 'styles/OrganisationUi/slice/selectors';
import {
  // OrganisationUiActionTypes,
  useOrganisationUiSlice,
} from 'styles/OrganisationUi/slice';
import { useThemeSlice } from 'styles/theme/slice';
import { DOMAIN } from 'config/api-variables';
import { removeHttpHttpsWww } from 'utils/tools/data-transformers';
import { usePreRoutingSlice } from './slice';
import {
  selectLatestVersion,
  selectLatestVersionLoading,
} from './slice/selectors';
import { AppDefaults } from 'config/global-enums';
import { Modal, Typography } from 'antd';

export default function RoutesLoader({ routes, ...props }) {
  const isAuthenticated = useSelector(selectAuthenticated);
  const isAuthLoading = useSelector(selectAuthLoading);

  const showInstallHeader = useSelector(selectInstallHeaderVisible);
  const showClientDomain = useSelector(selectIsClientDomain);

  const customTheme = useSelector(selectTheme);
  const orgUiDetails = useSelector(selectOrganisationUiDetails);

  const latestVersion = useSelector(selectLatestVersion);
  const latestVersionLoading = useSelector(selectLatestVersionLoading);

  const { actions } = useAuthenticationFormSlice();
  const { actions: commonActions } = useCommonFunctionSlice();

  const { actions: orgUiActions } = useOrganisationUiSlice();
  const { actions: themeActions } = useThemeSlice();
  const { actions: usePreRoutingActions } = usePreRoutingSlice();

  const [isModalVisible, setIsModalVisible] = useState(false);

  const dispatch = useDispatch();

  const recheckAuth = useCallback(() => {
    if (isAuthenticated && !getAuthKey()) {
      window.location.reload();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    clearCacheAndHardReload();

    window.addEventListener('storage', recheckAuth);

    if (isMobile && !window.location.pathname.split('/').includes('admin')) {
      // dispatch(commonActions.toggleInstallHeader());
    }
    if (getAuthKey() && getUserType()) {
      dispatch(actions.fetchProfileStart());
    } else {
      if (getAuthKey()) dispatch(actions.logoutStart());
      dispatch(actions.authPhoneEnd());
    }

    return () => window.removeEventListener('storage', recheckAuth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeTheme = themeKey => {
    dispatch(themeActions.changeTheme(themeKey));
  };

  useEffect(() => {
    if (
      orgUiDetails &&
      removeHttpHttpsWww(window.location.hostname) !==
        removeHttpHttpsWww(DOMAIN)
    ) {
      AddNewTheme(orgUiDetails, `${Date.now()}theme`, changeTheme);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgUiDetails]);

  useEffect(() => {
    import('antd/lib/config-provider/index')
      .then(module => module.default)
      .then(ConfigProvider =>
        ConfigProvider.config({
          theme: {
            primaryColor: customTheme.primary,
          },
        }),
      );
  }, [customTheme]);

  useEffect(() => {
    if (
      process.env.NODE_ENV !== 'development' &&
      removeHttpHttpsWww(window.location.hostname) !==
        removeHttpHttpsWww(DOMAIN)
    ) {
      dispatch(commonActions.toggleisCurrentClientDomain());
      dispatch(
        orgUiActions.fetchOrgUiDetailsStart({
          // actionFor: OrganisationUiActionTypes.FETCH_ORG_UI_DETAILS,
          organisation_domain: removeHttpHttpsWww(window.location.hostname),
          // organisation_domain: 'timbl.cleandesk.co.in',
        }),
      );

      if (
        removeHttpHttpsWww(window.location.hostname) === 'ozone.cleandesk.co.in'
      ) {
        dispatch(actions.toggleHideForOzone(false));
      }
    }

    fetchLatestVersion();

    const intervalId = setInterval(() => {
      fetchLatestVersion();
    }, 60 * 60 * 1000);
    // }, 20000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let prevScrollpos = window.pageYOffset;

  window.onscroll = function () {
    var currentScrollPos = window.pageYOffset;

    const extraActionElement = document.querySelectorAll('.extraActionBtn');
    if (extraActionElement?.length) {
      if (prevScrollpos > currentScrollPos) {
        for (const el of extraActionElement) {
          el.classList.remove('hide');
        }
      } else {
        for (const el of extraActionElement) {
          el.classList.add('hide');
        }
      }
    }

    const navbarElement = document.getElementById('navbar');
    if (navbarElement) {
      if (prevScrollpos > currentScrollPos) {
        // navbarElement.style.top = showInstallHeader
        //   ? StyleConstants.INSTALL_HEADER_HEIGHT
        //   : '0';
        navbarElement.style.top = 0;
      } else {
        navbarElement.style.top = `-${StyleConstants.NAV_BAR_HEIGHT}`;
      }
    }
    prevScrollpos = currentScrollPos;
  };

  const fetchLatestVersion = () => {
    dispatch(
      usePreRoutingActions.fetchLatestVersionStart({
        app_type: 'CUSTOMER',
      }),
    );
  };

  const UpdateVersionModal = () => {
    return (
      <Modal
        title={`Version v${latestVersion} is available`}
        open={isModalVisible}
        onOk={() => {
          window.location.reload();
          setIsModalVisible(false);
        }}
        onCancel={() => {
          setIsModalVisible(false);
        }}
        okText="Confirm"
        maskClosable={false}
        closable={false}
      >
        <Typography.Paragraph>
          A new version has been released. Would you prefer to update now? If
          you choose to cancel, the site will automatically update when you
          reopen it.
        </Typography.Paragraph>
      </Modal>
    );
  };

  useEffect(() => {
    if (latestVersion && !latestVersionLoading) {
      const compareVersions = (v1, v2) => {
        const v1Parts = v1.split('.').map(Number);
        const v2Parts = v2.split('.').map(Number);

        for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
          const v1Part = v1Parts[i] || 0;
          const v2Part = v2Parts[i] || 0;

          if (v1Part > v2Part) return 1;
          if (v1Part < v2Part) return -1;
        }
        return 0;
      };

      if (compareVersions(latestVersion, AppDefaults.APP_VERSION) > 0) {
        setIsModalVisible(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [latestVersion, latestVersionLoading]);

  return (
    <BrowserRouter>
      <MainHelmet />
      {/* <DelayChild delay={1500}>
        <InstallHeader />
      </DelayChild> */}

      <RoutesLoaderView
        {...props}
        routes={routes}
        showInstallHeader={showInstallHeader}
        showClientDomain={showClientDomain}
        isAuthenticated={isAuthenticated}
      />

      <DelayChild delay={1500}>
        {/* <LanguageSwitcher /> */}
        {!isAuthLoading && !isAuthenticated && <LazyPromptInstall />}
      </DelayChild>

      <UpdateVersionModal />
    </BrowserRouter>
  );
}
